import ReactGA from 'react-ga4';
import React, { useEffect } from 'react';
import Image from 'next/image';
import BaseModal from 'components/BaseModal';
import { makeStyles } from '@mui/styles';
import { closeModal } from 'features/workspace/generalSlice';
import { Box, Grid, Typography } from '@mui/material';
import { COLOR_GRAY_90 } from 'styles/variables/colors';
import CustomButton from 'components/CustomButton';
import PropTypes from 'prop-types';
import { Icons } from 'components/Icons';
import { useAuthUser } from 'features/auth/AuthUserContext';
import { useDispatch } from 'react-redux';

const Props = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export const useStyles = makeStyles((theme) => ({
  rootModal: {
    paddingBottom: theme.spacing(3),
    background: 'linear-gradient(to right, #eee 50%, #fff 50%);',
  },
  title: {
    fontSize: 28,
    fontFamily: 'Lato',
    fontWeight: 900,
    textAlign: 'center',
    color: '#D6246E',
    lineHeight: '38px',
    maxWidth: '188px',
  },
  textBenefits: {
    fontSize: 20,
    fontFamily: 'Lato',
    fontWeight: 700,
    color: COLOR_GRAY_90,
    lineHeight: '30px',
    padding: theme.spacing(2, 0, 4),
  },
  deletePrice: {
    color: '#FF0000',
  },
  alignTexts: {
    textAlign: 'left',
    paddingLeft: theme.spacing(14),
  },
  button: {
    paddingTop: theme.spacing(4),
  },
  iconAdd: {
    color: '#D6246E',
  },
}));

export default function AnniversaryMindTheGraphModal({ open, onClose }) {
  const { user } = useAuthUser();
  const classes = useStyles();
  const dispatch = useDispatch();

  function sendOpenTrackingEvents() {
    ReactGA.event({
      category: 'workspace',
      action: 'anniversary_banner_presented',
      label: 'Workspace Anniversary MTG Banner Presented',
      value: user.id,
    });
  }

  function sendClickTrackingEvents() {
    ReactGA.event({
      category: 'workspace',
      action: 'anniversary_banner_time_clicked',
      label: 'Workspace Anniversary Banner Clicked',
      value: user.id,
    });
  }

  function handleActionClick() {
    sendClickTrackingEvents();

    window.open(`/pricing?promotion=mind_the_graph_anniversary`);

    dispatch(closeModal());
  }

  useEffect(() => {
    if (open) {
      sendOpenTrackingEvents();
    }
  }, [open]);

  return (
    <BaseModal
      classes={{ paper: classes.rootModal }}
      open={open}
      size="md"
      fullWidth={false}
      content={
        <Box>
          <Grid container={true} spacing={2}>
            <Grid item={true} xs={12} sm={6}>
              <Box mr={-4.5}>
                <Image
                  src="/images/anniversary/anniversary-mtg-modal.png"
                  alt="Anniversary MTG"
                  width={640}
                  height={540}
                />
              </Box>
            </Grid>

            <Grid item={true} xs={12} sm={6}>
              <Box className={classes.alignTexts}>
                <Typography className={classes.title}>
                  Mind the 10th <br />
                  Anniversary
                </Typography>
              </Box>

              <Box className={classes.alignTexts}>
                <Typography className={classes.textBenefits}>
                  <del className={classes.deletePrice}>
                    <span style={{ color: '#212121' }}>344 USD</span>
                  </del>{' '}
                  in benefits <br />
                  for only 99 USD
                </Typography>

                <typography>
                  Researcher Annual Subscription <br /> from 344 USD for <b>99 USD</b>
                </typography>

                <Box py={1}>
                  <Icons.add className={classes.iconAdd} />
                </Box>

                <Typography>
                  Free gift:{' '}
                  <b>
                    200 USD Custom <br />
                    Graphical Abstract
                  </b>
                </Typography>

                <Box className={classes.button}>
                  <CustomButton onClick={handleActionClick} style={{ minWidth: '225px' }}>
                    Enjoy this Offer
                  </CustomButton>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      }
      cancelButton={false}
      actionButton={false}
      onClose={onClose}
    />
  );
}

AnniversaryMindTheGraphModal.propTypes = Props;
